// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"355":"portal","873":"manager"}[chunkId] + "." + {"355":"4321cec4","873":"15b09fbf"}[chunkId] + ".js";
};